let config = {};

config.api = {
    imagesMetadata: process.env.REACT_APP_CLOUDFRONT_DOMAIN_IMAGES_METADATA,
    images: process.env.REACT_APP_CLOUDFRONT_DOMAIN_IMAGES
}

config.environment = process.env.REACT_APP_NODE_ENV;
config.app = {
    title: 'FP Digital Photo',
    version: process.env.REACT_APP_BUILD_NUMBER,
    year: new Date().getFullYear()
};

if (config.environment === 'local')
    config.app.title += ' Local';
else if (config.environment === 'development')
    config.app.title += ' Dev';
else if (config.environment === 'staging')
    config.app.title += ' Stage';

export default config;